<template>
  <v-container class="booking-preview p-0" v-if="priceTiers" fluid>
    <vue-headful :title="$t('header.facility') + $t('title')"></vue-headful>
    <HkiaraceBannerFrame :is-snap-content="true">
      <v-row class="booking-preview-content">
        <v-col class="booking-preview-content-wrapper p-0">
          <v-row class="booking-preview-content-row mb-3 py-3">
            <v-col>
              <v-form v-model="isFormValid" class="booking-preview-form text-left">
                <v-container>
                  <v-row>
                    <v-col>
                      <v-row class="booking-preview-form-title">
                        <v-col>{{ $t('point_transaction.top_up_title') }}</v-col>
                      </v-row>

                      <v-row>
                        <v-col v-for="tier in priceTiers"
                               :key="tier.id"
                               cols="12" sm="6">
                          <v-card :class="['d-flex', 'mx-3', 'point-tier-container', {'selected': selectedPriceTierId === tier.id}]"
                                  @click="selectedPriceTierId = tier.id">
                            <v-card-text class="text-right">
                              <v-row class="point-tier-amount">
                                <v-col>{{ tier.amount }} <small>{{ $t('my_account.points') }}</small></v-col>
                              </v-row>
                              <v-row class="point-tier-price">
                                <v-col>HKD {{ tier.price }}</v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>

                      <v-row class="booking-preview-form-title">
                        <v-col class="pb-0">{{ $t('booking.payment_method') }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-card :class="['d-flex', 'mx-3', 'booking-preview-payment-method', {'active': paymentMethod === 'cyber_source'}]"
                                  @click="paymentMethod = 'cyber_source'">
                            <v-card-text>
                              <v-img :src="require('@/assets/logo-credit-cards.png')"
                                     height="100px"
                                     contain></v-img>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col cols="12" sm="3">
                          <v-card :class="['d-flex', 'mx-3', 'booking-preview-payment-method', {'active': paymentMethod === 'union_pay'}]"
                                  @click="paymentMethod = 'union_pay'">
                            <v-card-text>
                              <v-img :src="require('@/assets/logo-union-pay.png')"
                                     height="100px"
                                     contain></v-img>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row v-if="paymentMethod === 'cyber_source'">
                        <v-col>
                          <v-radio-group v-model="selectedPaymentToken">
                            <v-radio v-for="paymentToken in paymentTokens"
                                     :key="paymentToken.id"
                                     :value="paymentToken.id">
                              <template #label>
                                <v-img :src="cardTypeLogo[paymentToken.card_type]"
                                       :max-width="40"
                                       :max-height="30"
                                       class="mr-4"></v-img>
                                {{ `${paymentToken.card_number} (${paymentToken.card_expiry_date})` }}
                              </template>
                            </v-radio>
                            <v-radio :value="false">
                              <template #label>
                                <v-icon class="mr-4">fas fa-plus-square</v-icon>
                                {{ $t('booking_preview.add_payment_token') }}
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-checkbox light
                                      v-model="accepted"
                                      @click.stop="showTnc"
                                      validate-on-blur>
                            <template v-slot:label>
                              <div @click.stop="showTnc">{{ $t('booking_preview.accept_tnc1') }} {{ $t('booking_preview.accept_tnc2') }}</div>
                            </template>
                          </v-checkbox>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-col>
          </v-row>

          <v-row class="booking-preview-steps  py-2 px-2 py-md-6 px-md-6">
            <v-col :class="$vuetify.breakpoint.width <= 600?'text-center':'text-right'" :cols="$vuetify.breakpoint.width <= 600?6:12">
              <v-btn color="primary" rounded :large="$vuetify.breakpoint.width>600"
                     class="ml-2 my-2"
                     :disabled="!selectedPriceTierId || !accepted || !paymentMethod"
                     @click="next">
                <v-icon>mdi-arrow-right-circle-outline</v-icon>
                <span class="font-size-35">{{ $t('booking.next_step') }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </HkiaraceBannerFrame>
    <v-dialog v-model="tncDialogShown" scrollable>
      <v-card light v-if="tnc">
        <v-card-title class="tnc-title title-font">{{ tnc.title }}</v-card-title>

        <v-card-text @scroll="onScroll" v-html="tnc.content" class="text-left"></v-card-text>

        <v-card-actions class="tnc-actions">
          <v-spacer></v-spacer>
          <span v-if="!tncScrolledToBottom">{{ $t('booking.tnc_scroll_to_bottom') }}</span>
          <v-spacer></v-spacer>

          <v-btn text
                 :disabled="!tncScrolledToBottom"
                 class="tnc-action title-font"
                 @click="setAcceptTnc(true)">
            {{ $t('register.agree') }}
          </v-btn>

          <v-btn text
                 :disabled="!tncScrolledToBottom"
                 class="tnc-action title-font"
                 color="rgb(142, 118, 91)"
                 @click="setAcceptTnc(false)">
            {{ $t('register.disagree') }}
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core'
import {faExclamationCircle} from '@fortawesome/free-solid-svg-icons'
import HkiaraceBannerFrame from "@/components/HkiaraceBannerFrame";
import {onMounted, ref, watch} from '@vue/composition-api';

library.add(faExclamationCircle);

export default {
  name: 'PointTopUp',
  components: {HkiaraceBannerFrame},
  setup(props, {root}) {
    const priceTiers = ref([]);
    const getPriceTiers = function () {
      root.$callAPI('aafb/point/tiers/', {}, function (response) {
        priceTiers.value = response.body.tiers;
      })
    };
    const selectedPriceTierId = ref(null);

    const isFormValid = ref(false);

    const tnc = ref(null);
    const getTNC = function () {
      root.$callAPI('hkiarace/tnc/', {}, function (response) {
        tnc.value = response.body;
      });
    };
    const accepted = ref(false);
    const tncDialogShown = ref(false);
    const tncScrolledToBottom = ref(false);

    // Payment Token
    const paymentMethod = ref(null);
    const selectedPaymentToken = ref(false);
    const paymentTokens = ref([]);
    const cardTypeLogo = ref({
      '001': require('@/assets/visa.jpg'),
      '002': require('@/assets/mastercard.png'),
      '007': require('@/assets/jcb.gif'),
    });
    const getPaymentTokens = function () {
      root.$callAPI('payment/cyber_source/payment_tokens/', {}, (response) => {
        paymentTokens.value = response.body.payment_tokens;

        if (paymentTokens.value.length > 0) {
          selectedPaymentToken.value = paymentTokens.value[0].id;
        }
      })
    }
    watch(() => paymentMethod.value, (newValue) => {
      if (newValue === 'cyber_source') {
        getPaymentTokens();
      }
    })

    const showTnc = function (e) {
      e.preventDefault();

      if (!accepted.value) {
        // this.$bvModal.show('tncModal');
        tncDialogShown.value = true;
      } else {
        accepted.value = false;
      }
    };
    const setAcceptTnc = function (accept) {
      tncDialogShown.value = false;
      accepted.value = accept;
    };

    const onScroll = function ({target: {scrollTop, clientHeight, scrollHeight}}) {
      if (scrollTop + clientHeight >= (scrollHeight - 10)) {
        tncScrolledToBottom.value = true
      }
    };


    const postForm = function (path, params, method = 'post') {
      const form = document.createElement('form');
      form.method = method;
      form.action = path;

      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          const hiddenField = document.createElement('input');
          hiddenField.type = 'hidden';
          hiddenField.name = key;
          hiddenField.value = params[key];

          form.appendChild(hiddenField);
        }
      }

      document.body.appendChild(form);
      form.submit();
      root.$startLoading();
    }
    const next = function () {
      if (confirm(root.$t('booking_preview.redirect_warning'))) {
        this.$callAPI('aafb/point/init_payment/', {
          payment_method: paymentMethod.value,
          tier_id: selectedPriceTierId.value,
          payment_token_id: selectedPaymentToken.value,
        }, function (response) {
          postForm(response.body.url, response.body.params)
        });
      }
    };

    onMounted(() => {
      getPriceTiers();
      getTNC();
    });


    return {
      priceTiers,
      selectedPriceTierId,

      isFormValid,

      selectedPaymentToken,
      paymentTokens,
      cardTypeLogo,

      tnc,
      accepted,
      tncDialogShown,
      tncScrolledToBottom,
      onScroll,
      showTnc,
      setAcceptTnc,

      paymentMethod,
      next,
    }
  },
}
</script>

<style lang="less">
.booking-preview {
  .booking-preview-banner {
    .booking-preview-banner-label {
      position: absolute;
      left: 50%;
      top: 50%;
      color: white;
      font-size: 3rem;
      text-shadow: 2px 2px rgba(0, 0, 0, 0.25);
      transform: translate(-50%, -50%);
    }
  }

  .booking-preview-content {
    background-color: #efefef;

    .booking-preview-content-wrapper {
      /*transform: translateY(-120px);*/

      .datepicker-calendar {
        width: 100%;
        border: none;
        margin: auto;
      }

      .booking-preview-content-row {
        background-color: white;

        .booking-preview-form {
          max-width: 1024px;
          margin: auto;

          .v-label {
            color: #8E765B;
          }

          .v-input--is-readonly > .v-input__control > .v-input__slot:before {
            display: none;
          }

          .v-input--is-readonly > .v-input__control > .v-input__slot:after {
            display: none;
          }

          .booking-preview-form-title {
            font-size: 1.5rem;
          }

          .preview-warning-label {
            font-size: .8rem;
          }

          .booking-preview-payment-method {
            border: 2px solid rgba(0, 0, 0, 0.2);
            cursor: pointer;


            &:hover, &.active {
              border: solid 2px #998065;
              background-color: rgba(153, 128, 101, 0.2);
            }
          }
        }
      }

      .booking-preview-steps {
        .v-avatar {
          margin-right: 12px;
        }

        .mdi-arrow-right {
          margin-left: 24px;
          margin-right: 12px;
        }
      }
    }
  }

  .point-tier-container {
    border: 2px solid rgba(0, 0, 0, 0.2);

    .point-tier-amount {
      font-size: 150%;
      font-weight: bold;
    }

    .point-tier-price {

    }

    &.hover, &.selected {
      border: solid 2px #998065;
      background-color: rgba(153, 128, 101, 0.2);
    }
  }
}


.consent-dialog {
  min-width: 400px;
  max-width: 800px;
  width: 800px;
}


.gymVideoPlayer {
  width: 100%;
  height: 640px;
  max-height: 60vh;
  max-width: 80vw;
}

</style>
